import { css } from '@emotion/react'

import { size, width } from '@twisto/styles'

export const main = css`
  display: flex;
  flex-direction: column;
  gap: clamp(${size[48]}, 5vw + ${size[20]}, ${size[96]});
  max-width: ${width.container.wider};
  margin: clamp(${size[40]}, 5vw + ${size[16]}, ${size[80]}) auto;
  padding: 0 ${size[24]};
`
